import './respond.controller.js';



// WEBPACK FOOTER //
// ./components/appointments/appointment/respond/index.js